import React, {Component} from 'react'
import './CodeView.css'
import AceEditor from 'react-ace'
import 'brace/mode/python'
import 'brace/theme/vibrant_ink'

class CodeView extends Component {
  render() {
    return (
      <AceEditor mode="python" theme="vibrant_ink" fontSize="16px" value={this.props.children} height={this.props.height} className="editor" readOnly={true} style={{borderRadius:"8px",margin:"0 auto"}} />
    )
  }   
}

export default CodeView


// WEBPACK FOOTER //
// ./src/Prerequisites/CodeView/CodeView.js